var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.771,
    height: 12.575,
    viewBox: "0 0 17.771 12.575",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160526",
    "data-name": "Group 160526",
    transform: "translate(-1186.262 -419.982)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_670",
    "data-name": "Path 670",
    d: "M4.567,6H17.107a1.489,1.489,0,0,1,1.567,1.384v8.306a1.489,1.489,0,0,1-1.567,1.384H4.567A1.489,1.489,0,0,1,3,15.691V7.384A1.489,1.489,0,0,1,4.567,6Z",
    transform: "translate(1184.311 414.732)",
    fill: "none",
    stroke: "#111926",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_671",
    "data-name": "Path 671",
    d: "M18.674,9l-7.837,5.743L3,9",
    transform: "translate(1184.311 413.373)",
    fill: "none",
    stroke: "#111926",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.d550a4573a72a1dddfcbe7042cacb8ab.svg";
export { ForwardRef as ReactComponent };